/*#########################################################################################
#                                                                                         #
#    ThatWorks GLOBAL JS FILE                                                             #
#    ------------------------------                                                       #
#    Used for site-wide JS functionality.                                                 #
#                                                                                         #
#########################################################################################*/

/**
 * Debounce Execution Control
 *
 * Limits the rate of function execution for better performance.
 * @param {Function} func - Function to debounce.
 * @param {Number} wait - Delay in milliseconds before invoking.
 * @param {Boolean} immediate - Trigger on leading edge if true.
 *
 * @author Ahmed Ezzaouia
 */
function debounce(func, wait, immediate) {
  var timeout;
  return function (...args) {
    var context = this;
    var later = function () {
      timeout = null;
      if (!immediate) func.apply(context, args);
    };
    var callNow = immediate && !timeout;
    clearTimeout(timeout);
    timeout = setTimeout(later, wait);
    if (callNow) func.apply(context, args);
  };
}

/**
 * Slick Slider Initialization
 *
 * Initializes Slick sliders for elements with the specified class,
 * using data attributes for configuration if not already initialized.
 * @param {string} slick_class - Class selector for Slick elements.
 *
 * @author Ahmed Ezzaouia
 */
function thatworks_slickInit(slick_class) {
  console.log("I am called");
  var slickElements = $(slick_class);
  slickElements.each(function () {
    var slickElement = $(this);
    var slickData = slickElement.attr("data-slick");
    if (!slickData) return false;
    var slickSettings = JSON.parse(slickData.replace(/&quot;/g, '"'));
    if (!slickElement.hasClass("slick-initialized")) {
      slickElement?.slick(slickSettings);
    }
  });
}

/*#########################################################################################
#                                                                                         #
#    Event Listeners                                                                      #
#    -----------------                                                                    #
#    Hook functions to specific events here.                                              #
#                                                                                         #
#########################################################################################*/

document.addEventListener("DOMContentLoaded", function () {});

 

 

window.addEventListener("resize", debounce(function (e) {
    thatworks_slickInit(".thatworks-slides");
  }, 1500)
);

document.addEventListener("shopify:section:load", function (e) {
  thatworks_slickInit(".thatworks-slides");
});

document.addEventListener("shopify:section:reorder", function () {});

document.addEventListener("shopify:block:load", function (e) {
  thatworks_slickInit(".thatworks-slides");
});

/**
 * SlickCarousel Class
 *
 * This class represents a custom HTML element that initializes a Slick carousel
 * using jQuery. It retrieves configuration settings from a child script tag with
 * type 'application/json', and applies these settings to initialize the carousel.
 *
 * Methods:
 * - connectedCallback: Lifecycle method called when the element is added to the DOM.
 * - _init: Initializes the element by retrieving settings and initializing the Slick carousel.
 * - _getSettings: Retrieves and parses the JSON settings from a child script tag.
 * - _slickInit: Initializes the Slick carousel if it hasn't been initialized yet.
 * - _slickDestroy: Destroys the Slick carousel instance.
 *
 * @extends HTMLElement
 *
 * @example
 * <slick-carousel>
 *   <script type="application/json">
 *     {
 *       "dots": true,
 *       "slidesToShow": 3
 *     }
 *   </script>
 * </slick-carousel>
 *
 * @author
 */
class SlickCarousel extends HTMLElement {
  /**
   * Constructs a new instance of the SlickCarousel class.
   * Initializes the base HTMLElement by calling the super constructor.
   */
  constructor() {
    super();
  }

  /**
   * Lifecycle method called when the element is added to the DOM.
   * Initializes the element by retrieving settings and initializing the Slick carousel.
   * @author RCA
   */
  connectedCallback() {
    this._init();
  }

  /**
   * Initializes the SlickCarousel component by retrieving the settings
   * from the child script tag and selecting the carousel element. It
   * then calls the method to initialize the Slick carousel with the
   * retrieved settings.
   */
  _init() {
    this.settings = this._getSettings() || {};
    this.element = $(this).find(".slick-carousel");
    this._slickInit();
  }

  /**
   * Retrieves the settings from the child script tag with type
   * 'application/json' and parses it as a JSON object. Returns
   * the parsed settings object.
   *
   * @returns {Object} The parsed settings.
   * @author RCA
   */
  _getSettings() {
    return JSON.parse(
      this.querySelector("[type='application/json']").textContent
    );
  }

  /**
   * Initializes the Slick carousel for the current element if it hasn't been initialized yet.
   * The initialization is performed when the DOM content is fully loaded.
   * It checks if the element has the 'slick-initialized' class to avoid re-initialization,
   * and applies the Slick settings stored in the 'settings' attribute.
   *
   * @author RCA
   */
  _slickInit() {
    document.addEventListener("DOMContentLoaded", () => {
      if ($(this.element).hasClass("slick-initialized")) return;
      $(this.element).slick(this.settings);
    });
  }

  /**
   * Destroys the Slick carousel instance for the current element.
   * It uses the Slick "unslick" method to remove the carousel and its
   * associated event listeners.
   *
   * @author RCA
   */
  _slickDestroy() {
    $(this.element).slick("unslick");
  }

  /**
   * Lifecycle method called when the element is removed from the DOM.
   * Used for cleanup tasks, such as removing event listeners or
   * stopping timers. Logs a message indicating the SlickCarousel has been
   * disconnected.
   */
  disconnectedCallback() {
    console.log("SlickCarousel disconnected");
  }
}

customElements.define("slick-carousel", SlickCarousel);
